export default __webpack_public_path__ + "static/media/Somaiya_Logo.af3b937f.png";